import { memo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { LoopOutlined } from '@material-ui/icons'

import { appConfigStateSelectors } from '@tabeeb/modules/appConfigState'
import { regenerateBentleyAnalyticsReport } from '@tabeeb/modules/bentleyAnalyticsReport/actions'
import { gallerySelectors } from '@tabeeb/modules/gallery'
import { usersSelectors } from '@tabeeb/modules/../users'
import { isBentleyAnalyticsReportPage } from '@tabeeb/services/pageService'

import ToolbarButton from '../ToolbarButton'

const RegenerateAnalyticsReportButton = () => {
  const dispatch = useDispatch()

  const pageId = useSelector(gallerySelectors.getSelectedGalleryItemId)

  const isBentleyAnalyticsReportFeatureEnabled = useSelector(appConfigStateSelectors.getShowBentleyAnalyticsReport)

  const isReviewer = useSelector(usersSelectors.getIsCurrentUserReviewer)
  const isViewer = useSelector(usersSelectors.getIsCurrentUserViewer)

  const isBentleyAnalyticsReport = useSelector((state) =>
    isBentleyAnalyticsReportPage(gallerySelectors.getSelectedGalleryItemType(state))
  )

  if (!isBentleyAnalyticsReport) {
    return null
  }

  const handleClick = () => {
    dispatch(regenerateBentleyAnalyticsReport.request({ pageId }))
  }

  return (
    <ToolbarButton
      Icon={LoopOutlined}
      display={isBentleyAnalyticsReportFeatureEnabled && !isReviewer && !isViewer}
      title='Regenerate Analytics Report'
      onClick={handleClick}
    />
  )
}

export default memo(RegenerateAnalyticsReportButton)
